import Modal from "../../../../../../commons/Modal/Modal";
import ProspectPaymentForm from "./ProspectPaymentForm/ProspectPaymentForm";
import { ValidatePaymentModalProps } from "./ValidatePaymentModal.types";

export default ({ prospect, ...props }: ValidatePaymentModalProps) => {
  return (
    <Modal closeOnClickOutside {...props}>
      <ProspectPaymentForm {...{ prospect }} />
    </Modal>
  )
}